// formating numbet to to string '1,009,900,000,000'
export default function numberToCommasString(num) {
  if (!num || isNaN(num)) return num

  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
